export const [letters, alphabets, farsiLetter, NID, CID, mobileNum, number, phone] = [
    // eslint-disable-next-line max-len
    /^[a-zA-Z]+|^[\u0622\u0627\u0628\u067E\u062A-\u062C\u0686\u062D-\u0632\u0698\u0633-\u063A\u0641\u0642\u06A9\u06AF\u0644-\u0648\u06CC ]{1,30}$/,
    /^[a-zA-Z]+/,
    // eslint-disable-next-line max-len
    /^[\u0622\u0627\u0628\u067E\u062A-\u062C\u0686\u062D-\u0632\u0698\u0633-\u063A\u0641\u0642\u06A9\u06AF\u0644-\u0648\u06CC ]{1,30}$/,
    /^[0-9]{10}$/,
    /^[0-9]{3,16}$/,
    // eslint-disable-next-line max-len
    /(0|\+98)?9[0-9]{9}$|(\u06F0|\+\u06F9\u06F8)?\u06F9[\u06F0-\u06F9]{9}$/,
    /^\d+|^[\u06F0-\u06F9]+/,
    // eslint-disable-next-line max-len
    /(0|\+98)?9[0-9]{9}$|(\u06F0|\+\u06F9\u06F8)?\u06F9[\u06F0-\u06F9]{9}$|^[0-9]{5,11}$|^[\u06F0-\u06F9]{5,11}$/
];
